import { Navigate, Route, Routes } from 'react-router-dom'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { CampaignRoutes } from 'pages/campaigns/route/type'
import { CampaignLayout } from 'pages/campaigns/layout/CampaignLayout'
import { AllCampaigns, CreateCampaign, EditCampaign, DetailCampaign } from 'pages/campaigns/pages'
import { CampaignIdLayout } from 'pages/campaigns/layout/CampaignIdLayout'
import { CloneCampaign } from 'pages/campaigns/pages/clone/CloneCampaign'
import { CampaignsAccessLayout } from 'pages/campaigns/layout/CampaignsAccessLayout'

export const CampaignRouter = observer(() => {
  return (
    <Routes>
      <Route element={<CampaignsAccessLayout />}>
        <Route element={<CampaignLayout />}>
          <Route index element={<Navigate to={CampaignRoutes.all} />} />
          <Route path={CampaignRoutes.all} element={<AllCampaigns />} />
          <Route path={CampaignRoutes.create} element={<CreateCampaign />} />
          <Route element={<CampaignIdLayout />}>
            <Route path={`${CampaignRoutes.edit}/:id`} element={<EditCampaign />} />
            <Route path={`${CampaignRoutes.clone}/:id`} element={<CloneCampaign />} />
            <Route path={`${CampaignRoutes.detail}/:id`} element={<DetailCampaign />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
})
